import CreateProcess from "./simpler-process-manage";

export default CreateProcess